// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65bf352d","453":"4c49c97b","455":"ea9c3d4b","977":"2cdb9890"}[chunkId] + ".chunk.js";
};